import React, { useEffect, useState } from "react";

import bellSvg from "../../common/icons/svg/bell.svg";
import bellSolidSvg from "../../common/icons/svg/bell-solid.svg";
import threeDotsSvg from "../../common/icons/svg/three-dots.svg";
import crossSvg from "../../common/icons/svg/cross.svg";
import favoriteSvg from "../../common/icons/svg/favorite.svg";
import favoriteSelectedSvg from "../../common/icons/svg/favorite-selected.svg";
import "./BedListContainer.scss";
import { connect } from "react-redux";
import { bedDetailConfigAction, favoriteBedAction, modalAction } from "../../modules/actions/action";
import { ADD, DEVICE_TYPES, MODAL_ITEMS, REMOVE, BED_DETAILS_MODULE, SIDEBAR_ICON, SCORE_COLOR } from "../../common/constant/common-constants";
import { PAGE_CONST } from "../../common/constant/page-constants";
import { redirect } from "../../common/utils/RedirectionUtils";
import { getActiveModuleForBedDetails } from "../../common/utils/CommonUtils";
import { useNavigate } from "react-router-dom";
import AnimateBed from "../../common/utils/Animations/AnimateBed";

function BedListContainer(props) {
    const navigate = useNavigate();

    const [vitalList, setVitalList] = useState(props.listViewParameters || []);
    const [isOpen, setIsOpen] = useState(""); // update with bed-number
    const [bedIdArray, setBedIdArray] = useState(props.bedIdArray);
    const [showNotificationDetails, setShowNotificationDetails] = useState(false);

    useEffect(() => {

        setVitalList(props.listViewParameters || []);
    }, [props.listViewParameters])

    useEffect(() => {
        setBedIdArray(props.bedIdArray);
        // if (props.bedIdArray && props.bedIdArray.length > 0) {
        //     if (!lvSelectedBed) setLvSelectedBed(props.bedIdArray[0]);
        // }
    }, [props.bedIdArray])

    useEffect(() => {
        const favBedArray = props.favoriteBedIdArray;
        let tempBedArr = bedIdArray && bedIdArray.sort((a, b) => a - b);
        setBedIdArray([...tempBedArr]);
        let bd = (bedIdArray && bedIdArray.sort((a, b) => favBedArray.indexOf(b) - favBedArray.indexOf(a))) || [];
        setBedIdArray([...bd]);
    }, [props.favoriteBedIdArray]);

    const handleIsOpenClick = (bedId) => {

        if (isOpen === bedId) setIsOpen("");
        else setIsOpen(bedId);
    }

    const handleSolidBellClick = () => {
        setShowNotificationDetails(!showNotificationDetails);
    }

    const handleFavoriteClick = (event, type, bedId) => {

        event.stopPropagation();

        let arr = props.favoriteBedIdArray;
        let index = arr.indexOf(bedId);
        switch (type) {
            case ADD:
                if (arr.indexOf(bedId) < 0) {
                    arr.push(bedId);
                }
                break;
            case REMOVE:
                if (index > -1) {
                    arr.splice(index, 1);
                }
                break;
            default:
                break;
        }

        props.favoriteBedAction([...arr]);
    }

    const handleActionClick = (bedId, item) => {

        console.log("this action was clicked", item);
        // setIsOpen("");
        props.bedDetailConfigAction({
            activeModule: getActiveModuleForBedDetails(item)
        });

        // props.modalAction({
        //     isOpen: true,
        //     optionType: item,
        //     bedId: bedId
        // });

        let data = {
            bedId: bedId
        }
        redirect(navigate, PAGE_CONST.BED_DETAILS, data);
    }

    const handleScoreColor = (gcs, sofa, bedName) => {
        gcs = parseInt(gcs);
        sofa = parseInt(sofa);
        switch (true) {
            case (gcs <= 8 || sofa > 11):
                return SCORE_COLOR.RED;
            case ((gcs <= 12 && gcs >= 9) || (sofa >= 8 && sofa <= 11)):
                return SCORE_COLOR.YELLOW;
            case (gcs > 12 || sofa < 8):
                return SCORE_COLOR.GREEN;
            default:
                return ""
        }

    }


    return (
        <div className="bed-list-container">

            <table className="bed-list-table">
                <thead>
                    <tr className="bed-list-header-row">
                        <th className="bed-list-header bed">
                            BED
                        </th>
                        <th className="bed-list-header">
                        </th>
                        <th className="bed-list-header">
                            PATIENT ID
                        </th>
                        <th className="bed-list-header">
                            PATIENT
                        </th>
                        {/* {
                            vitalList.map((vitalObj) => {
                                return (
                                    <th className="bed-list-header" key={vitalObj.label}>
                                        {vitalObj.label}
                                    </th>
                                )
                            })
                        } */}
                        <th className="bed-list-header">
                            AGE
                        </th>
                        <th className="bed-list-header">
                            HEIGHT (cm)
                        </th>
                        <th className="bed-list-header">
                            WEIGHT (kg)
                        </th>
                        <th className="bed-list-header">
                            GENDER
                        </th>
                        <th className="bed-list-header">
                            {/* ACTIONS */}
                        </th>
                    </tr>
                </thead>
                <tbody>

                    <AnimateBed>
                        {bedIdArray.map((bedId) => {

                            let mData = props.deviceVitalData[bedId]
                                && props.deviceVitalData[bedId][DEVICE_TYPES.MONITOR];

                            let vData = props.deviceVitalData[bedId]
                                && props.deviceVitalData[bedId][DEVICE_TYPES.VENTILATOR];

                            let patientData = props.patientData[bedId] || {};


                            if (props.wardData && props.wardData.bedList && (props.wardData.bedList.indexOf(bedId) <= -1)) return;
                            let ref = React.createRef();
                            let bedName = props.bedDetails && props.bedDetails[bedId] && props.bedDetails[bedId].bedName;
                            return (<tr key={bedId} ref={ref}>
                                <td className="bed-list-body">
                                    <div className="bed-info-container">
                                        {(props.favoriteBedIdArray
                                            && props.favoriteBedIdArray.indexOf(bedId) < 0)
                                            && <div
                                                className="favorite-icon-container"
                                                onClick={(event) => handleFavoriteClick(event, ADD, bedId)}>
                                                <img className="favorite-icon" src={favoriteSvg} alt="favorite icon" />
                                            </div>}
                                        {(props.favoriteBedIdArray
                                            && props.favoriteBedIdArray.indexOf(bedId) > -1)
                                            && <div
                                                className="favorite-icon-container"
                                                onClick={(event) => handleFavoriteClick(event, REMOVE, bedId)}>
                                                <img className="favorite-icon" src={favoriteSelectedSvg} alt="favorite icon" />
                                            </div>}
                                        <div className="notification-container">
                                            {
                                                (!props.notificationData ||
                                                    !props.notificationData[bedId]) &&
                                                <div className="bell-icon-container">
                                                    <img className="bell-icon" src={bellSvg} alt="bell icon" />
                                                </div>}
                                            {
                                                props.notificationData &&
                                                props.notificationData[bedId] &&
                                                <div
                                                    className="bell-icon-container"
                                                    onClick={() => handleSolidBellClick()} >
                                                    <img className="bell-icon" src={bellSolidSvg} alt="bell solid icon" />
                                                </div>}
                                            {showNotificationDetails && <div className="notification-details">
                                                <div className="notification">
                                                    <div className="notification-name">
                                                        Tab Dolo given at 16:00
                                                    </div>
                                                    <div className="ack-button">
                                                        Acknowledge
                                                    </div>
                                                </div>
                                                <div className="notification">
                                                    <div className="notification-name">
                                                        Tab Dolo given at 16:00
                                                    </div>
                                                    <div className="ack-button">
                                                        Acknowledge
                                                    </div>
                                                </div>
                                                <div className="notification">
                                                    <div className="notification-name">
                                                        Tab Dolo given at 16:00
                                                    </div>
                                                    <div className="ack-button">
                                                        Acknowledge
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                        <div className="bed-number">{bedName}</div>
                                    </div>
                                </td>

                                {// TODO: update from here 
                                }
                                <td className="bed-list-body">
                                    <div className={`score-status ${handleScoreColor(patientData.latestGCSScore, patientData.latestSofaScore, patientData.uhid)}`}>

                                    </div>
                                </td>
                                <td className="bed-list-body">
                                    <div className="uhid">
                                        {patientData.uhid || '-'}
                                    </div>
                                </td>
                                <td className="bed-list-body">
                                    {/* <div className="patient-details">
                                        <span className="patient-name">{patientData.name || 'name'}</span>
                                        <span className="pipe"></span>
                                        <span className="patient-age">{patientData.age || 'name'}</span>
                                        <span className="pipe"></span>
                                        <span className="patient-gender">{patientData.gender || 'name'}</span>
                                    </div> */}
                                    <div className="">
                                        {patientData.name || "-"}
                                    </div>
                                </td>
                                <td className="bed-list-body">
                                    <div className="">
                                        {patientData.age || "-"}
                                    </div>
                                </td>
                                <td className="bed-list-body">
                                    <div className="">
                                        {patientData.height || "-"}
                                    </div>
                                </td>
                                <td className="bed-list-body">
                                    <div className="">
                                        {patientData.weight || "-"}
                                    </div>
                                </td>
                                <td className="bed-list-body">
                                    <div className="">
                                        {patientData.gender || "-"}
                                    </div>
                                </td>
                                {/* {
                                    vitalList.map((vitalObj) => {

                                        let vitalData;
                                        if (vitalObj.device === DEVICE_TYPES.MONITOR) {
                                            vitalData = mData && mData.vitals.filter(
                                                (mvital) => mvital.name && mvital.name.toUpperCase() === vitalObj.name
                                            )[0];
                                        } else if (vitalObj.device === DEVICE_TYPES.VENTILATOR) {
                                            vitalData = vData && vData.vitals.filter(
                                                (mvital) => mvital.name && mvital.name.toUpperCase() === vitalObj.name
                                            )[0];
                                        }

                                        return (
                                            <td className="bed-list-body" key={vitalObj.name}>
                                                {(vitalData && vitalData.data[0] && vitalData.data[0].value) || '-'}
                                            </td>
                                        )
                                    })
                                } */}
                                <td className="bed-list-body">
                                    <div className="action-container" onClick={() => handleIsOpenClick(bedId)} >
                                        {/* // <div className="action-icon-container" onClick={() => handleIsOpenClick(bedId)}>
                                        //     {(isOpen !== bedId) && <img className="action-icon" src={threeDotsSvg} alt="action icon" />}
                                        //     {(isOpen === bedId) && <img className="action-icon" src={crossSvg} alt="action icon" />}
                                        // </div> */}
                                        {props.activeSidebarIcon === SIDEBAR_ICON.PATIENT_BOOK && <span className="documentation"
                                            onClick={() => handleActionClick(bedId, BED_DETAILS_MODULE.PATIENT_DETAILS)}>
                                            View Documentation
                                        </span>}
                                        {props.activeSidebarIcon !== SIDEBAR_ICON.PATIENT_BOOK && patientData.name && <span className="documentation"
                                            onClick={() => handleActionClick(bedId, BED_DETAILS_MODULE.PATIENT_DETAILS)}>
                                            Start Documentation
                                        </span>}
                                        {props.activeSidebarIcon !== SIDEBAR_ICON.PATIENT_BOOK && !patientData.name && <span className="documentation"
                                            onClick={() => handleActionClick(bedId, BED_DETAILS_MODULE.PATIENT_DETAILS)}>
                                            Admit Patient
                                        </span>}
                                        {/* {(isOpen === bedId) && <div className="action-option-container">
                                            <div
                                                className="charting action-option"
                                                onClick={() => handleActionClick(bedId, MODAL_ITEMS.CHARTING)}
                                            >
                                                {MODAL_ITEMS.CHARTING}
                                            </div>
                                            <div
                                                className="doctor-notes action-option"
                                                onClick={() => handleActionClick(bedId, MODAL_ITEMS.DOCTOR_NOTES)}
                                            >
                                                {MODAL_ITEMS.DOCTOR_NOTES}
                                            </div>
                                            <div
                                                className="nurse-notes action-option"
                                                onClick={() => handleActionClick(bedId, MODAL_ITEMS.NURSE_NOTES)}
                                            >
                                                {MODAL_ITEMS.NURSE_NOTES}
                                            </div>
                                            <div
                                                className="prescription action-option"
                                                onClick={() => handleActionClick(bedId, MODAL_ITEMS.PRESCRIPTION)}
                                            >
                                                {MODAL_ITEMS.PRESCRIPTION}
                                            </div>
                                            <div
                                                className="alarm-history action-option"
                                                onClick={() => handleActionClick(bedId, MODAL_ITEMS.ALARM_HISTORY)}
                                            >
                                                {MODAL_ITEMS.ALARM_HISTORY}
                                            </div>
                                        </div>} */}
                                    </div>
                                </td>
                            </tr>);
                        })}
                    </AnimateBed>
                    {/* <tr className="bed-list-body-row-container">
                        <td className="bed-list-body">
                            <div className="bed-info-container">
                                <div className="favorite-icon-container">
                                    <img className="favorite-icon" src={favoriteSvg} alt="favorite icon" />
                                </div>
                                <div className="bell-icon-container">
                                    <img className="bell-icon" src={bellSvg} alt="bell icon" />
                                </div>
                                <div className="bed-number">1</div>
                            </div>
                        </td>
                        <td className="bed-list-body">
                            <div className="uhid">
                                096344874
                            </div>
                        </td>
                        <td className="bed-list-body">
                            <div className="patient-details">
                                Rahul
                                <span className="pipe"></span>
                                56
                                <span className="pipe"></span>
                                M
                            </div>
                        </td>
                        {
                            vitalList.map((header) => {
                                return (
                                    <td className="bed-list-body">
                                        75
                                    </td>
                                )
                            })
                        }
                        <td className="bed-list-body">
                            <div className="action-container">
                                <div className="action-icon-container" onClick={() => handleIsOpenClick()}>
                                    {!isOpen && <img className="action-icon" src={threeDotsSvg} alt="action icon" />}
                                    {isOpen && <img className="action-icon" src={crossSvg} alt="action icon" />}
                                </div>
                                {isOpen && <div className="action-option-container">
                                    <div className="charting action-option">Charting</div>
                                    <div className="doctor-notes action-option">Nurse Notes</div>
                                    <div className="nurse-notes action-option">Doctor Notes</div>
                                    <div className="prescription action-option">Prescription</div>
                                    <div className="alarm-history action-option">Alarm History</div>
                                </div>}
                            </div>
                        </td>
                    </tr> */}
                </tbody>
            </table >
        </div >
    )
}

const mapStateToProps = (state, ownProps) => {

    return {
        bedIdArray: state.bedDetailsReducer.bedIdArray,
        bedDetails: state.bedDetailsReducer.bedDetails,
        deviceVitalData: state.deviceVitalDataReducer.deviceVitalData,
        patientData: state.patientDataReducer.patientData,
        favoriteBedIdArray: state.bedDetailsReducer.favoriteBedIdArray || [],
        notificationData: state.notificationDataReducer.notificationData,
        listViewParameters: (state.configReducer.config && state.configReducer.config.listViewParameters),
        activeSidebarIcon: state.configReducer.config && state.configReducer.config.activeSidebarIcon,
    }
}

const mapDispatchToProps = (dispatch) => {

    return {
        favoriteBedAction: (payload) => dispatch(favoriteBedAction(payload)),
        bedDetailConfigAction: (payload) => dispatch(bedDetailConfigAction(payload)),
        modalAction: (payload) => dispatch(modalAction(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BedListContainer);

